import { heroStats } from '@/mocks/gossip';

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      {/* 顶部氛围纹理 */}
      <div className="pointer-events-none absolute inset-x-0 top-0 h-56 bg-gradient-to-b from-primary-100/60 to-transparent" />

      <div className="relative mx-auto grid max-w-[1240px] items-center gap-10 px-4 pb-14 pt-10 md:px-6 md:pb-20 md:pt-14 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14">
        {/* 文案侧 */}
        <div className="animate-readdy-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3.5 py-1.5 text-xs font-bold text-primary-700">
            <i className="ri-flashlight-fill" />
            新瓜速递 · 前线实时更新
            <span className="ml-0.5 flex h-1.5 w-1.5 rounded-full bg-primary-500" />
          </span>

          <h1 className="mt-6 font-heading text-3xl font-black leading-[1.15] tracking-tight text-foreground-950 md:text-[44px] md:leading-[1.12]">
            最新瓜都在首页
            <br />
            按时间线排好
            <br />
            <span className="text-primary-600">第一手实时更新</span>
          </h1>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-700 md:text-lg">
            新瓜速递和前场爆料都往首页拉，事件刚发酵就能看到。除了瓜本身，前后聊天记录、相关截图和最新动态也会一并汇总，不用东翻西找，吃瓜跟进不掉队。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#speed"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition hover:bg-primary-600"
            >
              <i className="ri-fire-line text-lg" />
              围观最新瓜
            </a>
            <a
              href="#commentBox"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 py-3 text-sm font-bold text-foreground-800 transition hover:border-primary-300 hover:text-primary-600"
            >
              <i className="ri-chat-3-line text-lg" />
              前排评论走起
            </a>
          </div>

          {/* 运营数据 */}
          <div className="mt-9 flex max-w-lg items-stretch divide-x divide-background-200 rounded-2xl border border-background-200/80 bg-background-50/80">
            {heroStats.map((s) => (
              <div key={s.label} className="flex-1 px-3 py-4 text-center">
                <p className="font-heading text-lg font-black text-foreground-950 md:text-xl">
                  {s.value}
                  <span className="ml-0.5 text-sm font-bold text-primary-600">{s.suffix}</span>
                </p>
                <p className="mt-1 text-xs text-foreground-600">{s.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* 大封面侧 */}
        <div className="animate-readdy-fade-up relative mx-auto w-full max-w-[520px] lg:max-w-none" style={{ animationDelay: '0.15s' }}>
          <div className="relative overflow-hidden rounded-[28px] border border-background-200/80">
            <img
              src="https://readdy.ai/api/search-image?query=Stylized%20pop-art%20editorial%20illustration%20of%20giant%20juicy%20watermelon%20halves%20with%20sparkling%20red%20flesh%20and%20deep%20green%20rind%2C%20dynamic%20splash%20with%20floating%20chat%20bubbles%20and%20comment%20hearts%20swirling%20around%20them%2C%20warm%20cream%20background%2C%20high%20contrast%20watermelon%20red%20and%20fresh%20green%20editorial%20palette%2C%20bold%20clean%20vector%20illustration%20style%2C%20energetic%20community%20vibe%2C%20no%20text%2C%20crisp%20detail&width=960&height=1160&seq=hero-cover-91&orientation=portrait"
              alt="91吃瓜 最新瓜速递实时更新的西瓜主题封面"
              title="91吃瓜 前线爆料 新瓜速递"
              className="aspect-[4/5] h-auto w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/25 via-transparent to-transparent" />
          </div>

          {/* 浮动前排气泡 */}
          <div className="animate-readdy-float absolute -left-3 top-8 hidden rounded-2xl border border-background-200 bg-background-50/95 px-4 py-3 shadow-none sm:block">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100 text-sm text-primary-600">
                <i className="ri-chat-smile-fill" />
              </span>
              <div>
                <p className="text-xs font-bold text-foreground-950">新瓜上桌啦</p>
                <p className="text-[11px] text-foreground-600">前排已就位 · 刚更新</p>
              </div>
            </div>
          </div>

          <div className="animate-readdy-float absolute -right-3 bottom-10 hidden rounded-2xl border border-background-200 bg-background-50/95 px-4 py-3 sm:block" style={{ animationDelay: '1.4s' }}>
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-100 text-sm text-accent-700">
                <i className="ri-chat-3-fill" />
              </span>
              <div>
                <p className="text-xs font-bold text-foreground-950">1.2 万人前排围观</p>
                <p className="text-[11px] text-foreground-600">评论区正热着</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}